export default "__VITE_ASSET__0e20c68d__"